// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-stadium-house -> aion-management-stadium-house -> terminal-two-one
// Generated: 2026-10-22T20:05:02.702Z
// Counts: 1 design, 98 content, 68 slot group, 0 collection binding, 9 section, 4 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities Built For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>YOUR NEW HOME AWAITS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "contact-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>WE'RE HERE TO HELP</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently asked questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE COMFORTS OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Make Yourself At Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.cta_banner_headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Live your best life at <span data-type=\"field-token\" data-field=\"property_name\"></span>.</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>A STILL-SHOT OF YOUR NEW LIFE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome To Terminal 21</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Pittsburgh</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Perfect location</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Furry friends welcome</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Because pets are family too.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_1_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet spa</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_2_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dog park</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_3_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet-friendly restaurants</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the Joy of Living in Your Dream Apartment</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>ACCESS YOUR RESIDENT PORTAL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Login</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentreview.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents say</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>In their own words</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Hear it from our residents.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>your perfect apartment is here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "socialfeedsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Follow us on social media</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>360° views right here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE CONVENIENCE OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-chatbot.position_side": {
    "overrideType": "VALUE",
    "customValue": "left",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Pet Policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Elevate your lifestyle at Terminal 21 in Pittsburgh, PA, where urban convenience meets luxury living. Enjoy a vibrant community with amenities like a co-working lounge, a dog park, and a speakeasy lounge. Choose from expertly <a href=\"https://www.liveterminal21.com/floor-plans/\">designed studio, one, or two-bedroom apartments</a> tailored for your needs. Your perfect home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.body": {
    "overrideType": "VALUE",
    "customValue": "<p>At Terminal 21 in Pittsburgh, PA, your lifestyle meets comfort. Choose from chic studios to spacious two-bedroom apartments, all with stunning city or river views. Enjoy our vibrant community, complete with a speakeasy lounge, fitness center, and pet-friendly spaces. Elevate your living experience today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Terminal 21 in Pittsburgh, PA, our stunning studio, one, and two-bedroom apartments offer modern living with stylish finishes and breathtaking views. Enjoy exclusive amenities like our speakeasy lounge, fitness center, and pet-friendly spaces. Elevate your lifestyle—secure your lease online today and embrace a vibrant community that fits you perfectly!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Terminal 21 in vibrant Pittsburgh, PA, our diverse floor plans—from cozy studios to spacious two-bedroom apartments—cater to all lifestyles. Each home exudes chic comfort and modern design. Have questions? Contact our leasing team today, and let us help you find your perfect space in the heart of the city!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.administrative_fee": {
    "overrideType": "VALUE",
    "customValue": "$200",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.application_fee": {
    "overrideType": "VALUE",
    "customValue": "$75",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.community_amenity_fee": {
    "overrideType": "VALUE",
    "customValue": "$150",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.month_to_month_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.reservation_fee": {
    "overrideType": "VALUE",
    "customValue": "$200",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_admin_billing_fee": {
    "overrideType": "VALUE",
    "customValue": "$5",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_electric": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_gas": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_water_sewer": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Terminal 21 <span> <a href=\"https://www.liveterminal21.com/neighborhood/\">in the heart of Pittsburgh, PA</a> </span> , stylish living awaits. Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans that blend comfort with modern elegance. Each space invites you to experience urban life in a unique way. Browse our available apartment homes to find your perfect fit!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Terminal 21 in Pittsburgh, each floor plan— <a href=\"https://www.liveterminal21.com/floor-plans/\">from studios to two-bedroom apartments</a> —offers vibrant living experiences. Engage in leisure at our speakeasy lounge or energize at the yoga studio. Picture yourself enjoying city or river views, surrounded by <a href=\"https://www.liveterminal21.com/amenities/\">exceptional amenities</a> like a dog park, co-working lounge, and more!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio - 2 Bedroom Apartments in Downtown Pittsburgh, PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Terminal 21 apartments in downtown Pittsburgh, your vibrant lifestyle begins with diverse floor plans— <a class=\"richtext-link\" href=\"https://www.liveterminal21.com/floor-plans/\">studio to two-bedroom apartments</a>. Nestled near cultural gems like Heinz Hall and the Andy Warhol Museum, enjoy the ease of city living. Step outside to find parks, universities, and a thriving arts scene right at your doorstep.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Terminal 21 &nbsp;apartments in Pittsburgh, PA—where modern living meets vibrant community life. Choose from stylish <a href=\"https://www.liveterminal21.com/floor-plans/\">studio, one, or two-bedroom floor plans</a>, that blend high-end urban living with a unique ecosystem of creative amenities, including a podcast studio, maker’s room, and a resident speakeasy lounge.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Terminal 21 in vibrant Pittsburgh, PA, where modern living meets comfort. Choose from stylish studio, one-bedroom, or spacious two-bedroom floor plans. Your resident portal is your key—log in to effortlessly pay rent, schedule maintenance, and access exclusive community updates. Elevate your lifestyle today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Terminal 21 in Pittsburgh, PA, we offer a range of thoughtfully designed floor plans—studio, one-bedroom, and two-bedroom apartments tailored for your lifestyle. Schedule a tour to experience vibrant community living, and see what our residents love about calling Terminal 21 home! Your ideal space awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Terminal 21 in vibrant Pittsburgh, PA! Our diverse floor plans—including cozy studios, spacious one-bedroom, and welcoming two-bedroom apartments—offer the perfect fit for your lifestyle. Keep an eye on your inbox; a team member will connect with you soon to enhance your living experience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Terminal 21 in Pittsburgh, PA, our thoughtfully designed floor plans—studio, one-bedroom, and two-bedroom—elevate urban living. Each apartment offers a unique blend of style and comfort. Enjoy the convenience and charm of our community. Ready to envision your future home? Take a virtual tour today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "apply-now-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "floorplanslist.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.cta_secondary_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "footer.emergency_badge": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a159e7-a80b-77ee-97d6-e8506cb14dfb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "2-1-1 New Jersey logo"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      }
    }
  },
  "propertyoverview.cta_secondary": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "amenitiesforyou.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-c3ad-740c-9b68-91199e7ee07c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center at Terminal 21 with weight benches, dumbbells, and colorful mural walls in Downtown Pittsburgh, Pennsylvania."
      }
    }
  },
  "amenitiesforyou.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Arcade & Billiards"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-e3fd-7290-9ccc-e07d5bfb2a81.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Arcade & Billiards game room at Terminal 21 with a pool table and ping-pong table in an industrial-style lounge in Downtown Pittsburgh, Pennsylvania."
      }
    }
  },
  "amenitiesforyou.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Yoga Studio"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-d4bf-74a5-a784-cfdab0135bae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Yoga Studio at Terminal 21 with hardwood floors, ballet barre, and mirrored walls in Downtown Pittsburgh, Pennsylvania."
      }
    }
  },
  "amenitiesforyou.amenity_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Speakeasy Lounge"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-deed-70aa-9c77-fc3b8e39d4a0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Speakeasy Lounge at Terminal 21 with a mirrored bar counter, orange chairs, and blue stools in Downtown Pittsburgh, Pennsylvania."
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-a08b-70aa-ac61-b0f33541c44d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright bedroom with a bed, nightstand lamp, framed art, and large windows with city view at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-c552-75cc-ade6-42e55c6fdfed.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern gym with weight machines, benches, and colorful mural walls under bright industrial lighting at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-b92d-7722-8e22-279a837cb43f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor community recreation room with a pool table, lounge seating, and a bar."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-d2e1-7655-bd8e-703a771b4d58.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Industrial-style fitness center with weight machines, benches, free weights, and mirrors."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166345/019d026a-aa2d-728c-b57a-eb490c37a2ef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern co-working space with vibrant accent walls, large table, and comfortable seating."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-7e9e-705c-846c-99280636a705.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen in a modern apartment with dark wood cabinets, stainless steel appliances, and a white island."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-8d9b-752f-824e-bdf4a84d030f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Furnished bedroom with a gray upholstered bed, two nightstands, open closet, and adjoining bathroom."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-9b84-70fc-97b3-a2f9f9a92bef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment living room with a navy sectional, large windows, and warm gold accents."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166345/019d026d-f873-7239-8cb0-775de681580d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of Pittsburgh skyline with bridges over the Allegheny River."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-f873-7239-8cb0-775de681580d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a riverfront city skyline with bridges and high-rise buildings."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-f1da-7124-ae08-a13529892a61.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a downtown skyline with skyscrapers and elevated highways."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-f557-743d-9785-a5c7ea5480f2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Nighttime train platform with a moving train and illuminated signs."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166345/019fd959-d363-7739-9be2-5cd6a17d1584.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog park with artificial turf and a vertical garden wall."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-b3b7-751d-89e6-ae7fab856388.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a brick apartment building with a storefront labeled Terminal 21 and a landscaped walkway."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-af68-7180-81a7-c7f5d42b06be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a brick apartment building with a glass entrance and stairs labeled Terminal 21."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-a7f5-745c-a33a-ad5088d24050.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Low-angle view of a tall brick apartment building with a large Terminal 21 sign at the base."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$125"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "2 Months' Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.parking_custom": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Motorcycle-Parking"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.parking_custom_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Car + Motorcycle Parking"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$275"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.parking_garage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Garage-Large Parking"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$250"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pest": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pest Control"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$3"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$5"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "COOL Amenities"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Discover how our community makes life convenient and fun."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "LUXURY HOMES"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Spaces designed for comfort, focus, and everyday living."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "APPLY"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Fill out the contact form and be one step closer to applying."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-1677-761b-a6ad-2e5670b3b2bd.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Apollo Cafe"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Restaurants"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.4"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Casual, long-running cafe for American breakfast & lunch items, with some Mediterranean options."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-3060-75e9-a3df-f8dfd2c2cd81.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Pennsylvania Macaroni Co."
      },
      "category": {
        "type": "VALUE",
        "customValue": "Shopping & Retail"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.7"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Long-standing shop providing Italian groceries, including cheese & pasta, plus a deli counter."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-6fc5-772a-b9fc-b160fe9af40f.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Point State Park"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Nature & Outdoor Attractions"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.6"
      },
      "description": {
        "type": "VALUE",
        "customValue": "36-acre park at the intersection of 3 rivers with boating, hiking, biking & a Fort Pitt museum."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-1b7c-71d8-9094-09c5b0ec9d60.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Bluebird Kitchen"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Restaurants"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.3"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Cozy eatery dishing up sandwiches, salads, soups and baked goods made from scratch, along with coffee."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-a075-7463-a192-bb5e7501b2bf.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "The Andy Warhol Museum"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.7 mi"
      },
      "description": {
        "type": "VALUE",
        "customValue": "The largest museum dedicated to a single artist in North America, spotlighting Warhol's art plus new works, performances & lectures."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-d287-7505-8309-3d705e63aeea.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Monongahela Wharf Landing"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Nature & Outdoor Attractions"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.5 mi"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Riverfront park with a paved walking & biking trail, flood-resistant native plants and waterside steps by the Mon."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-1686-714b-95bf-bad93d05deaf.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Meat & Potatoes"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Restaurants"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Elevated American comfort food & craft cocktails in a sophisticated gastropub setting."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-59d8-76c1-aed1-85d21562401d.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Stage AE"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.9"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Rock concert venue with a vast interior space & balcony also has outdoor seating  & an indoor club."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-166e-7490-9ad1-af748b0f0efb.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Gaucho Parrilla Argentina"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Restaurants"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.8"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Cheery Argentinian haunt with patio seating preparing wood-fire-grilled meats, plus salads & sides."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-1c7d-72a9-851e-9da44ff87abe.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Bakersfield Penn Ave"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Restaurants"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.8"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Tacos & a few other Mexican dishes are delivered in an upbeat, margarita-fueled atmosphere."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-7861-7577-b947-d3d06479e870.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Heinz Hall for the Performing Arts"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.4 mi"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Circa-1927 home of the Pittsburgh Symphony Orchestra, a grand space for evening concerts & musicals in the Cultural District."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-3c85-701a-965f-f8a46db3e758.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Proper Brick Oven & Tap Room"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Restaurants"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.8 mi"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Relaxed Italian spot for locally sourced pasta & oven-fired pizzas paired with a rotating lineup of tap beers into the evening."
      }
    }
  },
  "propertyoverview.image_hero": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026d-9b84-70fc-97b3-a2f9f9a92bef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment living room with a navy sectional, large windows, and warm gold accents."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.PetPolicyCallout": {
    "properties": {
      "paddingTop": "0px"
    }
  },
  "header.address_link": {
    "properties": {
      "paddingTop": "5px"
    }
  }
};
